import { moduleProviderFactory } from 'core/providers';
import { ShipmentInfoReturnList } from 'modules/shipment-info-return/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.shipment-info-return',
				pattern: '/shipment-info-return',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.shipment-info-return.list',
						pattern: '',
						authorization: 'shipmentStatusReturnSection.read',
						component: ShipmentInfoReturnList,
					},
				],
			},
		],
	});
})();
